export default __webpack_public_path__ + "static/media/go_to_bed.7a60702b.svg";